// FundBadge — a loud, unmissable label that marks WHICH fund universe a finance
// view belongs to. The two fund types must never be confused or commingled:
//   • Levy       — PWC appropriation (fund 2101-65-6560, Oracle/Mobius)
//   • Non-Profit — the 501(c)(4) operating books (Truist bank + QuickBooks Online)
// Used at the top of each dashboard so the separation is visually obvious.

type Kind = "levy" | "nonprofit";

const STYLES: Record<Kind, { label: string; sub: string; cls: string }> = {
  levy: {
    label: "Levy",
    sub: "PWC appropriation",
    // teal — the appropriation / government side
    cls: "bg-[#0E403A]/15 text-[#2a7a6c] border border-[#2a7a6c]/30",
  },
  nonprofit: {
    label: "Non-Profit",
    sub: "Truist / QBO",
    // violet — the 501(c)(4) operating books, distinct from the levy teal
    cls: "bg-[#8b5cf6]/12 text-[#8b5cf6] border border-[#8b5cf6]/30",
  },
};

export default function FundBadge({ kind }: { kind: Kind }) {
  const s = STYLES[kind];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${s.cls}`}
      title={
        kind === "levy"
          ? "Levy funds — PWC government appropriation, via Oracle/Mobius (the specific fund segment is shown on each page and flips 2101→2119 at the FY27 rollover)"
          : "Non-profit funds — the 501(c)(4) operating books (Truist bank + QuickBooks Online)"
      }
    >
      <span className="uppercase">{s.label}</span>
      <span className="font-normal opacity-75">· {s.sub}</span>
    </span>
  );
}
